<template>
<div>
  <router-view></router-view>
</div>
</template>

<script>
export default {
  name: "appointmentHome"
}
</script>

<style scoped>

</style>
